import { render, staticRenderFns } from "./NotificationsHeader.vue?vue&type=template&id=0326b5ae&scoped=true"
import script from "./NotificationsHeader.vue?vue&type=script&lang=ts"
export * from "./NotificationsHeader.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./NotificationsHeader.vue?vue&type=style&index=0&id=0326b5ae&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0326b5ae",
  null
  ,true
)

export default component.exports